// (100 - (((Add all break and WD minutes) / total minutes on channel) * 100))

const trackerApp = {};

trackerApp.adherenceCounter = function(scheduleTime, breakTime, winddownTime) {
    // return breakTime + winddownTime;
    return (100 - (( (breakTime + winddownTime) / scheduleTime ) * 100));
}

trackerApp.brbCounter = function(adherenceGoal, scheduleTime, winddownTime) {
    return ((((scheduleTime * (100 - adherenceGoal)) / 10) - (10 * winddownTime)) / 10)
}

trackerApp.adherenceCounterEventListener = function() {
    trackerApp['$adherenceForm'] = $('#adherence-form');

    trackerApp['$adherenceForm'].on('submit', function(event) {
        event.preventDefault();

        trackerApp.scheduledMinutes = parseInt($('#scheduled-minutes').val());
        trackerApp.breakMinutes = parseInt($('#break-minutes').val());
        trackerApp.winddownMinutes = parseInt($('#winddown-minutes').val());
        
        trackerApp.adherence = trackerApp.adherenceCounter(trackerApp.scheduledMinutes, trackerApp.breakMinutes, trackerApp.winddownMinutes).toFixed(2);

        $('#adherence-counter').text(trackerApp.adherence);
    })
}

trackerApp.brbCounterEventListener = function() {
    trackerApp['$brbForm'] = $('#brb-form');


    trackerApp['$brbForm'].on('submit', function(event) {
        event.preventDefault();

        trackerApp.adherenceGoalMinutes = parseInt($('#adherence-goal').val());
        trackerApp.scheduledMinutesTwo = parseInt($('#scheduled-minutes-two').val());
        trackerApp.winddownMinutesTwo = parseInt($('#winddown-minutes-two').val());

        trackerApp.brb = trackerApp.brbCounter(trackerApp.adherenceGoalMinutes, trackerApp.scheduledMinutesTwo, trackerApp.winddownMinutesTwo).toFixed(0);

        $('#brb-counter').text(trackerApp.brb);
    })
}



trackerApp.init = () => {
    console.log("App has been initialized");

    trackerApp.adherenceCounterEventListener();
    trackerApp.brbCounterEventListener();

    
}

// document ready
$(function() {
    // call the init method within the document ready function
    trackerApp.init();
})
